<script>
export default {
  name: "zlifepet-analises",

  inject: ["hdl"],

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],

  data() {
    return {
      self: null,
      items: [],
      search: {
        rows: 10,
        page: 1,
        pages: 1,
        records: 1,
        term: "",
        sortBy: "e.id",
        sortDesc: true,
      },
      filtros: {
        filiais: [],
        dateStart: "",
        dateEnd: "",
      },
      filiais: globalThis.Siggma.filiais,
      columns: [
        {
          text: "Data Diagnóstico",
          align: "center",
          value: "createdAt",
          sort: "e.createdAt",
          maxWidth: 150,
        },
        {
          text: "Filial",
          align: "center",
          value: "filialId",
          sort: "e.filialId",
          maxWidth: 80,
        },
        {
          text: "Usuário",
          align: "left",
          value: "usuario",
          sort: "e.usuario",
          maxWidth: 1000,
          format: ({ usuario }) => usuario.usUsrNom,
        },
        {
          text: "Cache",
          align: "center",
          value: "cache",
          sort: "e.cache",
          maxWidth: 100,
          format: ({ cache }) => cache ? "Sim" : "Não",
        },
        {
          text: "Em Testes",
          align: "center",
          value: "emTestes",
          sort: "e.emTestes",
          maxWidth: 100,
          format: ({ emTestes }) => emTestes ? "Sim" : "Não",
        },
      ],
    };
  },

  methods: {
    onOpened(hdl) {
      this.self = hdl;
      this.items = [];
      this.pesquisar();
    },
    pesquisar() {
      const params = JSON.parse(JSON.stringify(this.search));
      params.sidx = params.sortBy;
      params.sord = params.sortDesc ? "desc" : "asc";

      if (this.filtros.filiais.length > 0) {
        params.filiais = this.filtros.filiais.join(";");
      }

      for (const filtro of ["dateStart", "dateEnd"]) {
        if (this.filtros[filtro]) {
          params[filtro] = this.filtros[filtro];
        }
      }

      this.self.http(
        `${globalThis.Siggma.basePath}/app/zlife-pet-ai/consultar-historico`,
        params,
      ).then((resp) => {
        this.items = resp.rows;
        this.search.page = parseInt(resp.page);
        this.search.pages = resp.total;
        this.search.records = resp.records;
      }).catch(() => null);
    },
  },
};
</script>

<template>
  <s-janela bt-mi bt-ma is-responsive title="Histórico de Diagnósticos"
    :dad="hdl" :visible="visible" @opened="onOpened" @close="$emit('close')">
    <s-layout>
      <template v-slot:body>
        <div class="s-card"
          style="display: flex; flex-direction: column; gap: 0.25em">
          <div class="filtros">
            <label>Período:</label>
            <div class="filtro-datetime"><s-datetimepicker
                v-model="filtros.dateStart" type="datetime"
                time-format="HH:mm:ss" @input="pesquisar" /></div>
            <label style="text-align: center">até</label>
            <div class="filtro-datetime">
              <s-datetimepicker v-model="filtros.dateEnd" type="datetime"
                time-format="HH:mm:ss" @input="pesquisar" />
            </div>
            <label style="grid-column: 1;">Filiais:</label>
            <s-select2 multiple v-model="filtros.filiais"
              style="width: 100%; grid-column: span 3" @input="pesquisar">
              <option v-for="fil in filiais" :key="fil.cod" :value="fil.cod">
                {{fil.cod}} - {{fil.des}}
              </option>
            </s-select2>
            <button type="button" @click="pesquisar">
              <i class="mdi mdi-magnify mdi-18px">Pesquisar</i>
            </button>
          </div>
          <s-data-table :columns="columns" :items="items"
            :sort-by.sync="search.sortBy" :sort-desc.sync="search.sortDesc"
            @change-sort="pesquisar">
            <template #pagination>
              <s-pagination :page.sync="search.page" :pages="search.pages"
                :records="search.records" :rows.sync="search.rows"
                @change="pesquisar"></s-pagination>
            </template>
          </s-data-table>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" @click="$emit('close')">Fechar</button>
      </template>
    </s-layout>
  </s-janela>
</template>

<style scoped>
.filtros {
  gap: 0.5em;
  display: grid;
  width: fit-content;
  margin-bottom: 10px;
  align-items: flex-end;
  grid-template-columns: 1fr 210px 40px 210px auto;

  label {
    display: block;
    margin-bottom: 0.5em;
  }
}

.filtro-datetime {
  display: flex;
  text-align: center;
  align-items: flex-end;

  >input {
    flex: 1;
  }
}
</style>